module.exports = __webpack_public_path__ + "img/user.23d13a1d.png";